import { contentFromBlock, makeTodoItem } from './stickyContent';

/** Organisatorische Post-it-Vorlagen */
export const STICKY_BLOCKS = [
  {
    id: 'todo',
    label: 'Aufgaben',
    hint: 'Checkliste',
    color: 'butter',
    width: 280,
    height: 320,
    content: {
      title: 'Aufgaben',
      items: ['', '', ''],
      notes: '',
    },
  },
  {
    id: 'today',
    label: 'Heute',
    hint: 'Tagesfokus',
    color: 'peach',
    width: 280,
    height: 320,
    content: {
      title: 'Heute',
      items: ['Priorität 1', 'Priorität 2', 'Priorität 3'],
      notes: 'Nicht vergessen:\n',
    },
  },
  {
    id: 'week',
    label: 'Diese Woche',
    hint: 'Wochenplan',
    color: 'butter',
    width: 300,
    height: 340,
    content: {
      title: 'Diese Woche',
      items: ['Mo', 'Di', 'Mi', 'Do', 'Fr'],
      notes: '',
    },
  },
  {
    id: 'followup',
    label: 'Follow-up',
    hint: 'Nachfassen',
    color: 'sky',
    width: 280,
    height: 320,
    content: {
      title: 'Follow-up',
      items: ['Mail entwerfen', 'Senden', 'Antwort prüfen'],
      notes: 'Kontakt:\nWann:\nKanal: Mail / Call\n',
    },
  },
  {
    id: 'waiting',
    label: 'Warten auf',
    hint: 'Blocker',
    color: 'lilac',
    width: 280,
    height: 300,
    content: {
      title: 'Warten auf',
      items: ['Rückmeldung einholen', 'Erinnerung setzen'],
      notes: 'Von:\nBis:\nWas:\n',
    },
  },
  {
    id: 'meeting',
    label: 'Meeting',
    hint: 'Agenda',
    color: 'mint',
    width: 300,
    height: 340,
    content: {
      title: 'Meeting',
      items: ['Agenda vorbereiten', 'Einladung senden', 'Notizen teilen'],
      notes: 'Mit:\nWann:\nZiel:\n',
    },
  },
  {
    id: 'call',
    label: 'Anruf',
    hint: 'Telefonat',
    color: 'rose',
    width: 270,
    height: 300,
    content: {
      title: 'Anruf',
      items: ['Anrufen', 'Ergebnis notieren', 'Follow-up planen'],
      notes: 'Wen:\nNummer:\nGrund:\n',
    },
  },
  {
    id: 'campaign',
    label: 'Kampagne',
    hint: 'Tracking',
    color: 'sky',
    width: 300,
    height: 340,
    content: {
      title: 'Kampagne',
      items: ['Antwort prüfen', 'Follow-up senden', 'Notiz aktualisieren', 'Status setzen'],
      notes: 'Kontakt:\nStatus:\nNächstes FU:\n',
    },
  },
  {
    id: 'inbox',
    label: 'Postfach',
    hint: 'Mail-Triage',
    color: 'peach',
    width: 280,
    height: 320,
    content: {
      title: 'Postfach',
      items: ['Wichtig beantworten', 'Spam aussortieren', 'Termine eintragen'],
      notes: '',
    },
  },
  {
    id: 'priority',
    label: 'Prioritäten',
    hint: 'A / B / C',
    color: 'rose',
    width: 280,
    height: 300,
    content: {
      title: 'Prioritäten',
      items: ['A — muss heute', 'B — diese Woche', 'C — irgendwann'],
      notes: '',
    },
  },
  {
    id: 'idea',
    label: 'Idee',
    hint: 'Brainstorm',
    color: 'mint',
    width: 260,
    height: 280,
    content: {
      title: 'Idee',
      items: ['Skizze machen', 'Mit jemandem besprechen'],
      notes: 'Warum interessant:\n',
    },
  },
  {
    id: 'errands',
    label: 'Erledigungen',
    hint: 'Privat / Büro',
    color: 'lilac',
    width: 280,
    height: 300,
    content: {
      title: 'Erledigungen',
      items: ['', '', ''],
      notes: '',
    },
  },
];

export { contentFromBlock, makeTodoItem };
